import {
  countyIdFromSeoPage,
  countySeoJurisdictionName,
  type CountySeoPageRecord,
} from "../data/county-seo-pages";

/** Public guide context is a starting hint, never proof of a property's county. */
export interface CountyGuideCheckContext {
  guide: string;
  countyId: string;
  countyName: string;
  stateAbbr: string;
  appealYear: number;
}
export function countyGuideCheckHref(page: Pick<CountySeoPageRecord, "stateSlug" | "countySlug">): string {
  return `/check?${new URLSearchParams({ guide: `${page.stateSlug}/${page.countySlug}` })}`;
}

export function countyGuideCheckContext(page: CountySeoPageRecord): CountyGuideCheckContext {
  return {
    guide: `${page.stateSlug}/${page.countySlug}`,
    countyId: countyIdFromSeoPage(page),
    countyName: countySeoJurisdictionName(page),
    stateAbbr: page.stateAbbr,
    appealYear: page.deadline.taxYear,
  };
}

export function isCountyGuideCheckContext(value: unknown): value is CountyGuideCheckContext {
  if (!value || typeof value !== "object") return false;
  const context = value as Record<string, unknown>;
  return typeof context.guide === "string" && /^[a-z-]+\/[a-z-]+$/.test(context.guide) &&
    typeof context.countyId === "string" && /^[a-z0-9_]{1,80}$/.test(context.countyId) &&
    typeof context.countyName === "string" && context.countyName.length > 0 && context.countyName.length < 100 &&
    typeof context.stateAbbr === "string" && /^[A-Z]{2}$/.test(context.stateAbbr) &&
    typeof context.appealYear === "number" && Number.isInteger(context.appealYear) &&
    context.appealYear >= 2000 && context.appealYear <= 2100;
}
